import { Component, Input, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { ArquivoAnexoModel } from '@shared/models/backend'
import { RadioFieldProvider } from '@widgets/radio-field/radio-field-provider'
import { FileDownloaderService } from '../file-downloader/file-downloader.service'
import { fileReviewValidator } from './file-review.validator'

@Component({
  selector: 'app-file-review',
  templateUrl: './file-review.component.html',
  styleUrls: ['./file-review.component.scss'],
})
export class FileReviewComponent implements OnInit {
  @Input()
  anexoModel: ArquivoAnexoModel = null

  @Input()
  viewAsCoordenador = false

  @Input()
  form: FormGroup

  arquivoValidoRadioProvider: RadioFieldProvider<boolean>
  validator = fileReviewValidator
  constructor(private fileDownloaderService: FileDownloaderService) {}

  get title() {
    return this.anexoModel?.dsAnexo
  }

  get arquivo() {
    return this.anexoModel?.arquivo
  }

  get filename() {
    return this.arquivo?.nome
  }

  download() {
    this.fileDownloaderService.download(this.arquivo)
  }

  get arquivoValidoControl() {
    return this.form.controls.arquivoValido
  }

  get arquivoValidoControlError() {
    const control = this.arquivoValidoControl
    const errors = control?.errors
    const errorText: string =
      control.invalid && (control.dirty || control.touched) && errors ? Object.values(errors)[0] : null
    return !this.viewAsCoordenador && errorText?.length > 0 ? errorText.slice(0, -1) : null
  }

  get isArquivoInvalido() {
    return this.form?.controls.arquivoValido.value === false
  }

  get isArquivoValido() {
    return this.form?.controls.arquivoValido.value === true
  }

  ngOnInit(): void {
    if (this.form?.controls) {
      this.form.controls.arquivoValido.valueChanges.subscribe((value) => {
        if (value) {
          this.form.controls.arquivoParecer.reset()
        }
      })
    }
  }
}
